
export class StopSort{
    constructor(){}

    sortByHaversineDistance(stop1,stop2){
        var d1 = stop1.haversine;
        var d2 = stop2.haversine;
        return (d1-d2);
    }

    sort(dataArray){
        return dataArray.sort(this.sortByHaversineDistance.bind(this))
    }
}